import * as React from 'react';
import { Box, useTheme } from '@material-ui/core';

// A single timeline entry: bold title, muted subtitle, optional extra content (comment, attachments, ...).
export interface TimelineItem {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  content?: React.ReactNode;
}

export interface TimelineProps {
  items: TimelineItem[];
  emptyLabel: string;
}

// Shared vertical timeline — same geometry as the old default `timeline-list` (rail at left:14px/width:4px,
// 14px filled marker with an 8px center, items padded 36px), recolored with the theme-fleet palette.
const Timeline: React.FC<TimelineProps> = ({ items, emptyLabel }) => {
  const theme = useTheme();
  const accent = theme.palette.primary.main;

  if (items.length === 0) {
    return <b>{emptyLabel}</b>;
  }

  return (
    <Box style={{ position: 'relative', width: '100%', paddingTop: 16 }}>
      {/* Continuous vertical rail spanning the whole list. */}
      <Box
        style={{
          position: 'absolute',
          top: 0,
          left: 14,
          height: '100%',
          width: 4,
          borderRadius: 4,
          background: accent
        }}
      />
      {items.map((item, index) => (
        <Box key={index} style={{ position: 'relative', padding: '5px 0 5px 36px', marginBottom: 16 }}>
          <Box style={{ position: 'relative' }}>
            {/* Filled marker with an inner light dot, centered on the rail. */}
            <Box
              style={{
                position: 'absolute',
                left: -27,
                top: 1,
                width: 14,
                height: 14,
                borderRadius: 20,
                background: accent
              }}
            >
              <Box
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  margin: '-4px 0 0 -4px',
                  width: 8,
                  height: 8,
                  borderRadius: 20,
                  background: theme.palette.common.white
                }}
              />
            </Box>
            <Box style={{ fontWeight: 700, color: theme.palette.text.primary }}>{item.title}</Box>
            {item.subtitle ? (
              <Box style={{ marginTop: 8, fontWeight: 700, color: theme.palette.grey[400], fontSize: 13 }}>
                {item.subtitle}
              </Box>
            ) : null}
            {item.content ? (
              <Box style={{ marginTop: 8, color: theme.palette.text.primary }}>{item.content}</Box>
            ) : null}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default Timeline;
